<template>
    <div class="modal fade" id="loginModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="background-filter">
                <div class="modal-content">
                    <div class="modal-header text-center">
                        <figure class="logo-pop-up">
                            <img loading="lazy" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="pop-logo">
                        </figure>
                        <button ref="close_btn" type="button" class="btn-close"
                            data-bs-dismiss="modal" aria-label="Close" @click="refreshData($siteSettings?.data?.business_type == 2 ? 1 : 2)">
                            <img loading="lazy" src="@/assets/images/close-btn.webp" alt="close-btn">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="registration-form tig-login-form-wrapper">
                            <h2  class="register-title">{{ $t('login-cap','LOGIN')}}</h2>
                            <div class="tab-login-sec">
                                <ul class="nav nav-tabs" id="myTab" role="tablist"  v-if="$siteSettings?.data?.business_type == 2">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" :class="form.type == 1 ? 'active': ''" id="phone-tab" data-bs-toggle="tab"
                                            data-bs-target="#phone" type="button" role="tab" aria-controls="phone"
                                            aria-selected="true" @click="form.type = 1,refreshData(1)">{{ $t('mobile-number','Mobile Number')}}</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" :class="form.type == 2 ? 'active': ''" id="user-tab" data-bs-toggle="tab" data-bs-target="#user"
                                            type="button" role="tab" aria-controls="user" aria-selected="false"
                                            @click="form.type = 2,refreshData(2)">{{ $t('user-id','User ID')}}</button>
                                    </li>
                                </ul>
                                <div class="tab-content" id="myTabContent" v-if="$siteSettings?.data?.business_type == 2">
                                    <div class="tab-pane fade" :class="form.type == 1 ? 'show active': ''" id="phone" role="tabpanel" aria-labelledby="phone-tab">
                                        <!-- <label for="" class="form-cmn-title">{{ $t('mobile-number','Mobile Number')}}*</label> -->
                                        <div class="phone-inpt-sec">
                                            <div class="slt-country-code">
                                                <select v-model="form.code" class="form-select textfirst-con " :disabled="demoLoading || loading"
                                                aria-label="Default select example">
                                                <option :value="allowedCountry.phonecode"
                                                    v-for="(allowedCountry, countryIndex) in $siteSettings?.data?.country_code_list"
                                                    :key="countryIndex">+{{ allowedCountry.phonecode }}</option>
                                                </select>
                                            </div>
                                            <div class="get-mob">
                                                <div class="input-number-box">
                                                    <input type="tel"  @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999);"  minlength="10" maxlength="10" v-model="form.mobileNo" 
                                                    :disabled="demoLoading || loading"
                                                    class="form-control add" id="autoSizingInput" :placeholder="$t('mobile-number','Mobile Number') + '*'">
                                                </div>
                                                <div  class="justify-content-start  password-wrong-con" v-if="init && checkValidation?.mobile?.length > 0">
                                                    <p v-for="(err, index) in checkValidation?.mobile" :key="index" class="wrong-color">{{ $t(err.lang, err.error) }}</p>
                                                </div>
                                                <div class="justify-content-start password-wrong-con" v-if="init && form.mobileNo.length == 10 && !timerRunning && loginMethod == 'otp'">
                                                    <p class="wrong-color">{{ $t('please-click-on-send-otp','Please Click on Get OTP') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="form.type == 1">
                                            <div class="d-flex login-method-section mt-2 mb-2">
                                                <div>
                                                    <input class="form-check-input flexRadioDefault-sec" type="radio" name="login-method" id="login-password" value="password" v-model="loginMethod" @click="toggleotp" @change="form.password = ''">
                                                    <label for="login-password" class="ps-1 text-white">{{$t('password', 'Password')}}</label>
                                                </div>
                                                <div class="ms-2">
                                                    <input class="form-check-input flexRadioDefault-sec" type="radio" name="login-method" id="login-otp" value="otp" v-model="loginMethod"  @click="toggleotp" @change="form.password = ''">
                                                    <label for="login-otp" class="ps-1 text-white">{{$t('otp', 'OTP')}}</label>
                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <div class="tab-pane fade" :class="form.type == 2 ? 'show active': ''" id="user" role="tabpanel" aria-labelledby="user-tab">
                                        <div class="form-group">
                                            <!-- <label for="" class="form-cmn-title">{{ $t('user-id','User ID')}}*</label> -->
                                            <div class="get-mob">
                                                <input type="text" v-model="form.userId" class="form-control add" id="autoSizingInput" @input="validateUserId, form.userId = $helper.sanitizeDetails('oldLoginUserId', form.userId)" 
                                                :placeholder="$t('user-id','User ID') + '*'" :disabled="demoLoading || loading">
                                                <div class="inp-img"><img loading="lazy" src="@/assets/images/user_icon.svg" alt=""></div>
                                            </div>
                                            <div  class="justify-content-start password-wrong-con" v-if="init && checkValidation?.userId?.length > 0">
                                                <p v-for="(err, index) in checkValidation?.userId" :key="index" class="wrong-color">{{ $t(err.lang, err.error) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-content" id="myTabContent" v-else>
                                    <div class="tab-pane fade show active" id="user" role="tabpanel" aria-labelledby="user-tab">
                                        <div class="form-group">
                                            <!-- <label for="" class="form-cmn-title">{{ $t('user-id','User ID')}}*</label> -->
                                            <div class="get-mob">
                                                <input type="text" v-model="form.userId" @input="validateUserId" class="form-control add" id="autoSizingInput" 
                                                :placeholder="$t('user-id','User ID') + '*'" :disabled="demoLoading || loading">
                                                <div class="inp-img"><img loading="lazy" src="@/assets/images/user_icon.svg" alt=""></div>
                                            </div>
                                            <div  class="justify-content-start password-wrong-con" v-if="init && checkValidation?.userId?.length > 0">
                                                <p v-for="(err, index) in checkValidation?.userId" :key="index" class="wrong-color">{{ $t(err.lang, err.error) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="form-group mb-0">
                                <div class="get-mob"  v-if="loginMethod == 'password'">
                                    <!-- <label for="" class="form-cmn-title">{{$t('password','Password')}}*</label> -->
                                    <div class="get-mob password-input-field">
                                        <input :type="passwordFieldType" v-model="form.password" @input="validatePassword, form.password = $helper.sanitizeDetails('oldLoginPassword', form.password);" :disabled="demoLoading || loading"
                                        class="form-control" id="inputPassword2" :placeholder="$t('password','Password') + '*'">
                                        <div class="inp-img"><img loading="lazy" src="@/assets/images/key_icon.svg" alt="key"></div>
                                        <div class="eye-icn-sec" @click="toggleShow('password')">
                                            <img loading="lazy" v-if="passwordFieldType=='text'" src="@/assets/images/eye-open.webp" alt="eye-open" >
                                            <img loading="lazy" v-else src="@/assets/images/eye-close.png" alt="eye-close">
                                        </div>
                                    </div>
                                </div>
                                <div class="get-mob"  v-if="loginMethod == 'otp'">
                                    <!-- <label for="" class="form-cmn-title">{{$t('otp','OTP')}}*</label> -->
                                    <div class="otp_field_wrapper">
                                        <input @input="form.password = $helper.sanitizeNumber(form.password,999999);" :readonly="loginMethod == 'otp' && !isOtpApiCalled" type="text" maxlength="6" v-model="form.password" :placeholder="$t('otp','OTP') + '*'" class="form-control" id="inputPassword2" >
                                        <span class="btn btn-primary place-but send-login-otp password-show-hide" :class="{'btn-disabled' : isOtpApiCalled && (minutes > 0 || seconds > 0) || loadingOtp}" v-if="loginMethod == 'otp'" @click="sendOtpServiceCall('login-otp')">
                                            {{ isOtpApiCalled && (minutes > 0 || seconds > 0) ? formatTime(minutes) + ':' + formatTime(seconds) : loadingOtp ? '' : (minutes == 0 ? $t('resend-otp','Resend OTP') : $t('get-otp','Get OTP')) }}
                                            <div v-if="loadingOtp" class="loader_spinner">
                                                <div class="spinner-border auth_loader otp_btn_loader" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </span> 
                                    </div>
                                </div>
                                <div class="justify-content-start password-wrong-con" v-if="init && checkValidation?.password?.length > 0 && ((loginMethod === 'otp' && isOtpApiCalled) || loginMethod === 'password')">
                                    <p class="wrong-color text-capitalize" v-for="(err, index) in checkValidation?.password" :key="index">{{ $t(`please-enter-${loginMethod.toLowerCase()}`,`Please Enter ${loginMethod}`)}}</p>
                                </div>
                            </div>
                           
                            <div class="check-box-sec form-container-sec" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                                <div class="for-pass">
                                    <a data-bs-toggle="modal" href="#staticBackdrop-two" @click="refreshData(1)">
                                        {{$t('forgot-password','Forgot Password?')}}
                                    </a>
                                </div>
                            </div>

                            <div class="login-option">
                                <div class="form-group demo-login">
                                    <a @click="demoUserLogin()" class="btn btn-submit btn-login" :class="{ 'btn-loading': demoLoading }">
                                        {{$t('demo-login','Demo Login')}} 
                                        <!-- <span><b></b><b></b><b></b></span> -->
                                        <span><img loading="lazy" src="@/assets/images/loading.gif"></span>
                                    </a>
                                </div>
                                <div class="form-group">
                                    <a @click="signInMethodCall()" class="btn btn-submit btn-login" :class="{ 'btn-loading': loading }">
                                        {{$t('login','Login')}} 
                                        <!-- <span><b></b><b></b><b></b></span> -->
                                         <span><img loading="lazy" src="@/assets/images/loading.gif"></span>
                                    </a>
                                </div>
                            </div>
                            <div v-if="$siteSettings?.data && $siteSettings?.data?.social_link && $siteSettings?.data?.social_link?.whatsappno1 && $siteSettings?.data?.business_type == 2"
                                class="whats-app">
                                <p class="create t-center">
                                    {{$t('get-your-ready-made-id-from-whatsapp','Get Your Ready-Made ID From Whatsapp')}}
                                </p>
                                <div class="button-whatsapp">
                                    <a :href="'//wa.me/' + $siteSettings?.data?.social_link.whatsappno1" target="_blank"
                                        type="button" class="btn-whatsapp"> <img loading="lazy" src="@/assets/images/whatsapp.webp" alt="whatsapp">
                                        {{$t('whatsapp-now','Whatsapp Now')}} </a>
                                </div>
                            </div>
                            <div class="other-login-option" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                                 <h3>{{$t('or-login-with','Or Login With')}}</h3>
                                 <ul class="login-by-social-icon">
                                     
                                     <li>
                                        <a v-if="$siteSettings?.data?.social_link?.facebook_link" :href="$siteSettings?.data?.social_link?.facebook_link" target="_blank">
                                            <img loading="lazy" src="@/assets/images/facebook-share.svg" alt="facebook">
                                        </a>
                                    </li>
                                     
                                     <li>
                                        <a v-if="$siteSettings?.data?.social_link?.telegram_link" :href="$siteSettings?.data?.social_link?.telegram_link" target="_blank">
                                            <img loading="lazy" src="@/assets/images/telegram.webp" alt="telegram">
                                        </a>
                                    </li>
                                     
                                     <li>
                                        <a v-if="$siteSettings?.data?.social_link?.instagram_link" :href="$siteSettings?.data?.social_link?.instagram_link" target="_blank">
                                            <img loading="lazy" src="@/assets/images/instagram.webp" alt="instagram">
                                        </a>
                                    </li>
                                    
                                 </ul>
                             </div>

                            
                            
                            <p class="whats-with-acc" v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">{{$t('dont-have-an-account',"Don't Have An Account?")}} &nbsp;<a data-bs-toggle="modal"
                                    data-bs-target="#Register" @click="refreshData(1); $emit('open-register')">{{$t('register','Register')}}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlternateSiteModal />
</template>

<script>
import axios from 'axios';
import { setHeaders } from '@/shared/services/headers';
import { AUTH_TOKEN } from '@/shared/constants/cookies-const';
import validate from '../services/authValidation';
import { defineAsyncComponent } from 'vue';
export default {
    name: "Login",
    components: {
		AlternateSiteModal: defineAsyncComponent(() =>
            import('@/shared/components/modal/AlternateSiteModal.vue')
        ),
	},
    computed: {
        checkValidation() {
            const validationErrors = validate.areFieldsValid(
                'login', 
                this.form.type, 
                this.form.mobileNo, 
                this.form.userId, 
                this.form.password
            );
            if(this.init){
                return validationErrors;
            }
        }
    },
    data() {
        return {
            form: {
                code: this.$siteSettings?.data && this.$siteSettings?.data.country_code ? this.$siteSettings?.data.country_code : 91,
                mobileNo: "",
                userId: "",
                password: "",
                type: this.$siteSettings?.data?.business_type == 2 ? 1 : 2
            },
            styleObject: {
                display: "none",
            },
            loading: false,
            demoLoading: false,
            passwordFieldType:'password',
            init:false,
            phnInit:false,
            loginMethod: 'password',
            minutes: 5,
            seconds: 59,
            loadingOtp: false,
            inputvalue :[
                {
                    value: 100,
                    isSelected: false,
                },
                {
                    value: 500,
                    isSelected: false,
                },
                {
                    value: 1000,
                    isSelected: false,
                },
                {
                    value: 2000,
                    isSelected: false,
                }                    
            ],
            loggedUserCheck: null,
        };
    },
    methods: {
        getType(){
            if(this.$siteSettings?.data?.business_type == 1) {this.form.type = 2};
            return this.form.type == 2 ? 'userid' : 'phone'
        },
        toggleShow(fieldName) {
            if(fieldName == 'password'){
                this.passwordFieldType = (this.passwordFieldType === 'text') ? 'password' : 'text';
            }
        },

        demoUserLogin() {
            this.form.type = 1;
             this.form.userId="demouser";
            this.form.password = "demopass";
            this.loginServiceCall('DEMO_LOGIN_API', 'demo')
        },
        refreshData(formtype = 1) {
            this.form = {
                code: this.$siteSettings?.data && this.$siteSettings?.data.country_code ? this.$siteSettings?.data.country_code : 91,
                mobileNo: "",
                userId: "",
                password: "",
                type:formtype,
                "cncode": this.form.code,
            },
            this.loginMethod = 'password';
            this.isOtpApiCalled = false;
            this.minutes = 5;
            this.seconds = 59;
            this.passwordFieldType = 'password';
            this.init = false
            this.phnInit = false;
            this.toggleLogin();
        },
        signInMethodCall() {
            this.init = true;
            let id = this.getId();
            if(id && this.form.password) {
                if(this.loginMethod == 'otp'){
                    if(this.isOtpApiCalled)
                    {
                        this.signInwithOtp();
                    }
                }
                else{
                    this.loginServiceCall('LOGIN_API', 'nondemo');
                }
            }
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
        toggleotp(){
            this.isOtpApiCalled = false,
            this.otpSent = false,
            this.isDisabled = true,
            this.resendOtp = false,
            this.timerRunning = false,
            this.init = false
        },
        setResendTimer() {
            const countdown = () => {
                if (this.minutes === 0 && this.seconds === 0) {
                    this.timerRunning = false;
                    // Timer has expired, you can perform any action here
                } else {
                    if (this.seconds === 0) {
                        this.minutes--;
                        this.seconds = 59;
                    } else {
                        this.seconds--;
                    }
                    setTimeout(countdown, 1000);
                }
            };
            setTimeout(countdown, 1000);
        },
        async sendOtpServiceCall(auth_type) {

            this.init = true;

            // trigger validation
            if (this.checkValidation?.mobile?.length > 0) {
                return;
            }

            const mobileStr = this.form.mobileNo?.toString().trim() || '';

            if (mobileStr.length !== 10) {
                this.$errorToast(this.$t('phone-number-between-10-digits', 'Phone Number Must Be Between 10 Digits'));
                return;
            }
            this.loadingOtp = true;
            let data = {
                type: auth_type,
                mobile: this.form.mobileNo, 
                countrycode: this.form.code
            }
            this.$apiCall('post', 'SEND_OTP', data).then(response => {
                this.loadingOtp = false;
                if (response) {
                    if (response.status == 200) {
                        this.$successToast(response.data.data);
                        this.isOtpApiCalled = true;
                        this.timerRunning = true;
                        this.minutes = 5;
                        this.seconds = 0;
                        this.setResendTimer();
                    }
                }
            }).catch(error => {
                this.loadingOtp = false;
                if (error)
                    this.$errorToast(error[0])
            });
        },
        signInwithOtp() {
            let id = this.getId();
            this.loading = true;
            let data = {
                mobile: id,
                countrycode: this.form.code,
                otp: this.form.password
            };
            this.$apiCall('post', 'LOGIN_WITH_OTP', data).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response.data.error) {
                            this.$errorToast(response?.data?.error);
                        } else {
                        
                            this.$successToast(response.data.success);
                            let userData = response.data;
                            if(this.loggedUserCheck!=userData?.user?.userid){
                                this.$store.dispatch('setClickBetValue', this.inputvalue);
                            }          
                            this.$cookies.set(AUTH_TOKEN, userData?.user?.token);
                            this.$store.dispatch('setToken', `Bearer ${userData?.user?.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            //for add on all APIs
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            this.$store.dispatch('setSiteVersion', null);
                            setHeaders();
                            this.setUserDataToStore(userData);
                            this.setUserIdsToStore(userData?.user?.userid)
                            localStorage.setItem("LoggedUser",userData?.user?.userid, this.form.type)
                            this.refreshData(1);
                            this.$router.push({name:'Home'});
                            setTimeout(() => {
                                location.reload();
                            }, 100);
                        }
                    }
                }
            }).catch(error => {

                this.loading = false;
                if (error) {
                    if(error[1] && error[1]?.alternate_link){
                        this.$siteSettings.data.alternate_link = error[1]?.alternate_link;
                        this.$helper.openModal('#AlternateSiteModal');
                    }
                    this.$errorToast(error[0]);
                }
            });
        },
        async loginServiceCall(url,type) {
            if (type == 'demo') {
                this.demoLoading = true;
            } else {
                this.loading = true;
            }
            let id = this.getId();
            let data = {
                "userid": id.toString(),
                "type": this.getType(),
                "countrycode": this.form.code,
                "password": this.form.password,
            };
            this.$apiCall('post', url, data).then(response => {
                if (type == 'demo') {
                    this.demoLoading = false;
                } else {
                    this.loading = false;
                }
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response.data.error) {
                            this.$errorToast(response.data.error);
                        } else {
                            this.$successToast(response.data.success);
                            let userData = response?.data;
                            if(this.loggedUserCheck != userData?.user?.userid){
                                this.$store.dispatch('setClickBetValue', this.inputvalue);
                            }
                            if (type === 'demo') {
                                userData.demoLogin = true
                            } else {
                                userData.demoLogin = false
                            }
                            this.$cookies.set(AUTH_TOKEN, userData?.user?.token);
                            this.$store.dispatch('setToken', `Bearer ${userData?.user?.token}`);
                            window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                            // for add on all APIs
                            axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                            localStorage.setItem('login_type', this.form.type)
                            this.$store.dispatch('setSiteVersion', null);
                            setHeaders();
                            localStorage.setItem("LoggedUser", userData?.user?.userid)
                            this.setUserDataToStore(userData);
                            this.setUserIdsToStore(userData?.user?.userid, this.form.type)
                            this.refreshData(data.type);
                            // this.$router.go();
                            this.closeModal();
                            this.$router.push({name:'Home'});
                            setTimeout(() => {
                                location.reload();
                            }, 100);
                        }
                    }
                }
            }).catch(error => {
                if (type == 'demo') {
                    this.demoLoading = false;
                } else {
                    this.loading = false;
                }
                if (error) {
                    console.log("Error Login : ", error);
                    this.$errorToast(error[0]);
                }
            });
        },


        clickOnType(type) {
            this.form.type = type;
            this.styleObject.display = "none";
            this.form.userId = "";
            this.form.mobileNo = "";
        },
        getId() {
            if (this.$siteSettings?.data?.business_type == 2) {
                return this.form.type == 1 ? this.form.mobileNo : this.form.userId;
            } else {
                return this.form.userId;
            }
        },
        closeModal() {
            this.$refs.close_btn.click();
        },
        setUserDataToStore(userData) {
            let user = {
                notificationSubscribed:null,
                notificationUnsubscribed:null,
                isDemoLogin: userData.demoLogin,
            }
            this.$store.dispatch('setUser', { ...userData?.user, ...user});
            this.$store.dispatch('setChips', userData?.user?.chips);
            this.$store.dispatch('setEventManage', userData?.event_manage);
        },
        setUserIdsToStore(userId, fromType) {
            let oldUserIds = this.$store.getters?.logInData?.userIds || [];
            if(fromType == 2) {
                if(this.$auth?.user?.last_login_at){
                    oldUserIds.push(userId);
                }
                let data = {
                    logInWithMobile: false,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
            else {
                let data = {
                    logInWithMobile: true,
                    userIds: oldUserIds
                }
                this.$store.dispatch('setLogInData', data);
            }
        },
        toggleLogin() {
            const LoginBtn = document.getElementById('LoginBtn');
            if (LoginBtn) LoginBtn.classList.remove('active');
        }
    },
    mounted() {
        // if(localStorage.getItem('login_type') && this.$siteSettings?.data?.business_type == 2) {
        //     this.form.type = localStorage.getItem('login_type');
        // }
        this.loggedUserCheck = localStorage.getItem('LoggedUser')
    },
    unmounted() {
        document.body.classList.remove('login-body-bg', 'inner-body');
    },

};
</script>

<style scoped>

@keyframes stretch {
    0% {
        transform: scale(0.5);
        background-color: #B5DDF0;
    }

    50% {
        background-color: #CFE9F6;
    }

    100% {
        transform: scale(1);
        background-color: #FFFFFF;
    }
}

.btn.btn-loading span {
    display: flex;
    justify-content: center;
}

.btn.btn-loading span b {
    animation-direction: alternate;
    animation-duration: 0.5s;
    animation-fill-mode: none;
    animation-iteration-count: infinite;
    animation-name: stretch;
    animation-play-state: running;
    animation-timing-function: ease-out;
    border-radius: 100%;
    display: block;
    height: 10px;
    margin: 0 1px;
    width: 10px;
    animation-delay: 0.1s;
    margin: 0 5px;
}

.btn.btn-loading span b:first-child {
    animation-delay: 0s;
    margin: 0;
}

.btn.btn-loading span b:last-child {
    animation-delay: 0.2s;
    margin: 0;
}

.btn span {
    display: none;
}

.placed-bet-btn.btn-loading {
    padding: 10px;
}

.btn-disabled {
    pointer-events: none;
    opacity: .65;
}
.login-option .btn-submit {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 5px;
}
.login-option .btn-submit img {
    height: 20px;
    width: 20px;
}

</style>